import React, { useMemo } from "react";
import { min, max, bin, group } from "d3-array";
import chroma from "chroma-js";
import { binned } from "../graphs/common/utils";
import { scaleLinear } from "d3-scale";
import { XAxis, XAxisTitle, YAxis, YAxisTitle } from "./common/Axis";

import { deriveLineFunction } from "../graphs/common/utils";
import LinePlot from "./LinePlot";


const AreaDensity = ({ data, channel, width, height }) => {

    console.log(data);
    console.log(channel);
    const margin = { top: 50, right: 50, bottom: 50, left: 70 };
    const innerWidth = width - margin.left - margin.right;
    const innerHeight = height - margin.top - margin.bottom;

    const num_bins = 10;
    const bins = binned(data, num_bins, channel);
    console.log(bins);

    const xExtent = [min(bins, d => d.x0), max(bins, d => d.x1)];

    const yExtent = [0, max(bins, d => d.length)];
    //calculate colors

    const colors = ['rgb(255,255,0)'];
    const color = chroma.scale(colors);


    //calculate scales

    const { xScale, yScale } = useMemo(() => {

        const xScale = scaleLinear().domain(xExtent).nice().rangeRound([0, innerWidth]);

        const yScale = scaleLinear().domain(yExtent).nice().rangeRound([innerHeight, 0]);

        return { xScale, yScale };

    }, [data, innerHeight, innerWidth, xExtent, yExtent]);

    if (!data) return <div style={{ width, height }} />

    return (
        xScale && yScale && width && height ?
            <div className="relative">
                <svg width={width} height={height}>
                    <g transform={`translate(${margin.left} ${margin.top})`}>
                        <XAxis
                            xScale={xScale}
                            title={channel}
                            height={height}
                            marginBottom={margin.bottom}
                            innerHeight={innerHeight}
                            gridLineHeight={innerHeight}
                        />
                        <YAxis
                            gridLineWidth={innerWidth}
                            yScale={yScale}

                            title="Frequency"
                        />
                        <XAxisTitle
                            title={channel}
                            xScale={xScale}
                            innerHeight={innerHeight}
                        />
                        <YAxisTitle title="Frequency" />

                        <LinePlot data={bins}
                            xScale={xScale}
                            yScale={yScale}
                            color={color}
                        />



                    </g>

                </svg>
            </div>
            : <div>"Scale not Defined "</div>

    )
}

export default AreaDensity;
